// Generated by CoffeeScript 1.12.7
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/components/progress_bar',['require','underscore','backbone'],function(require) {
  var ProgressBar, View, _;
  _ = require('underscore');
  View = require('backbone').View;
  return ProgressBar = (function(superClass) {
    extend(ProgressBar, superClass);

    function ProgressBar() {
      return ProgressBar.__super__.constructor.apply(this, arguments);
    }

    ProgressBar.prototype.id = 'progress-bar';

    ProgressBar.prototype.total = 0;

    ProgressBar.prototype.value = 0;

    ProgressBar.prototype.$value = null;

    ProgressBar.prototype.$progress = null;

    ProgressBar.prototype.initialize = function(options) {
      this.total = options.total || 0;
      this.value = options.value || 0;
      this.render();
      return this.progress();
    };

    ProgressBar.prototype.render = function() {
      var $counter;
      $counter = $('<div>').addClass('progress-counter');
      this.$value = $('<span>').addClass('progress-value').text('0%').appendTo($counter);
      this.$progress = $('<div>').addClass('progress').append($counter);
      this.$el.append(this.$progress);
      $('body').append(this.$el);
      return this.$el;
    };

    ProgressBar.prototype.progress = function() {
      return this.setValue(this.value + 1);
    };

    ProgressBar.prototype.setValue = function(value, total) {
      var percent;
      if (total != null) {
        this.total = total;
      }
      if (value != null) {
        this.value = value;
      }
      percent = Math.ceil(this.value / this.total * 100);
      this.$progress.css('width', percent + "%");
      if (percent >= 100) {
        this.$el.addClass('done');
      }
      return this.$value.html(percent + "<span>%</span>");
    };

    ProgressBar.prototype.destroy = function(callback) {
      return this.$el.fadeOut((function(_this) {
        return function() {
          _this.$el.remove();
          return callback();
        };
      })(this));
    };

    return ProgressBar;

  })(View);
});

